<db-dialog-wrapper [dialog]="this" [width]="'680px'" [canClose]="!loading" [hasCloseButton]="!loading" [canCloseByBackdrop]="!loading" [fullScreen]="isMobile">
  <div class="db-custom-https db-custom-https-sm" dbCustomScrollbar>
    <div class="db-custom-https-dialog__header">Add Custom SSL Certificate</div>
    <p class="db-custom-https-dialog__sub-header">To apply your SSL, paste .key and .cert files in its respective field.</p>
    <div class="db-custom-https-dialog__message">
      <div>
        <form [formGroup]="generateCustomCertificate" class="db-custom-https-dialog__custom_certificate">
          <div>
            <div *ngIf="serverErrors && serverErrors.message && !hasServerFieldErrors" class="db-server-error-wrap">
              <div class="db-server-error">{{serverErrors.message}}</div>
            </div>
            <span>Content of .key file</span>
            <textarea name="keyFileContents" formControlName="keyFileContents" class="noselect"></textarea>
            <div class="db-server-error-wrap">
              <div class="db-server-error" *ngIf="serverErrors?.fields.key_file_content">{{serverErrors?.fields.key_file_content[0]}}</div>
              <div class="db-server-error" *ngIf="(generateCustomCertificate.controls['keyFileContents'].invalid && generateCustomCertificate.controls['keyFileContents'].errors && generateCustomCertificate.controls['keyFileContents'].touched)">.key file content is required</div>
            </div>
          </div>
          <div>
            <span>Content of .cert file and .ca file</span>
            <p class="db-small">Paste content of files under each other</p>
            <textarea name="certFileContents" formControlName="certFileContents" class="noselect"></textarea>
            <div class="db-server-error-wrap">
              <div class="db-server-error" *ngIf="serverErrors?.fields.cert_file_content">{{serverErrors?.fields.cert_file_content[0]}}</div>
              <div class="db-server-error" *ngIf="generateCustomCertificate.controls['certFileContents'].invalid && generateCustomCertificate.controls['certFileContents'].errors && generateCustomCertificate.controls['keyFileContents'].touched">.cert file content is required</div>
            </div>
            <p class="db-small">In the case of a fullchain.pem file, paste entire content in the above field.</p>
          </div>
        </form>
      </div>
    </div>

    <div class="db-custom-https-dialog__buttons" *ngIf="selectedDialog === 'custom_certificate'">
      <a class="db-button" (click)="cancel()" [ngClass]="{'db-button_disabled': loading}"><span>{{'text_cancel' | dbText}}</span></a>
      <a class="db-button db-button_info" (click)="generateCertificate()">
        <span *ngIf="!loading">{{'text_generateCertificate' | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</db-dialog-wrapper>
